import Requisicao from "./RequisicaoService";

class AparelhoService {    
    static async listar(dados) { 
        return Requisicao.post('aparelho/listar', dados);                  
    }    
}

export default AparelhoService;